import './ImagesCarousel.css';
import { useState, useEffect } from 'react';

export default function ImageCarousel({ Images, offer }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  // 1. Budujemy listę TYLKO z tego, co faktycznie dostajemy
  const items = [];

  // Sprawdzamy zdjęcia
  if (Images && Array.isArray(Images) && Images.length > 0) {
    Images.forEach(img => {
      items.push({ type: 'image', src: img.uploadedUrl || img.url });
    });
  }

  // Sprawdzamy YouTube
  if (offer?.YouTubeURL) {
    items.push({ type: 'youtube', src: offer.YouTubeURL });
  }

  // Reset indexu
  useEffect(() => {
    setCurrentIndex(0);
  }, [offer?.id]);

  // DIAGNOSTYKA: Jeśli tablica jest pusta, wyświetl czerwony komunikat
  if (items.length === 0) {
    return (
      <div style={{ width: '250px', height: '300px', border: '5px solid red', background: 'yellow', color: 'black', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', fontSize: '12px' }}>
        DEBUG: Komponent działa, ale NIE MA DANYCH!<br/>
        Link: {offer?.YouTubeURL ? "Jest" : "Brak"}<br/>
        Images: {Images ? "Są" : "Brak"}
      </div>
    );
  }

  const currentItem = items[currentIndex];

  return (
    <div className="carousel-container"> 
      {/* Zielone tło powie nam, czy kontener w ogóle istnieje */}
      
      {items.length > 1 && (
        <button className="carousel-LeftButton" onClick={(e) => { e.stopPropagation(); setCurrentIndex(prev => (prev === 0 ? items.length - 1 : prev - 1)); }}>◀</button>
      )}

      {currentItem.type === 'image' ? (
        <img src={currentItem.src} className="carousel-image" alt="foto" /> 
      ) : (
        <div className="carousel-video-wrapper">
          <iframe
            key={currentItem.src}
            className="carousel-video"
            src={currentItem.src}
            title="YouTube video"
            allowFullScreen
          />
        </div>
      )}

      {items.length > 1 && (
        <button className="carousel-RightButton" onClick={(e) => { e.stopPropagation(); setCurrentIndex(prev => (prev === items.length - 1 ? 0 : prev + 1)); }}>▶</button>
      )}
    </div>
  );
}